import React, { useEffect, useState } from "react";
import { FaCaretDown } from "react-icons/fa";

const Header = () => {
  const [user, setUser] = useState({
    name: "",
    image: "",
    role: "",
    office: ""
  });

  useEffect(() => {
    // Fetch user data from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser({
        name: parsedUser.name,
        image: parsedUser.image,
        role: parsedUser.role,
        office: parsedUser.office
      });
    }
  }, []);

  return (
    <div className="flex items-center justify-between p-4 border-b bg-white z-10">
      {/* Left Section - Empty for balance */}
      <div className="flex-1"></div>

      {/* Middle Section - Office Name */}
      <div className="flex-1 flex justify-center">
        {user.office && (
          <div className="text-center">
            <div className="text-xs text-gray-500 uppercase tracking-wider font-semibold">
              Office
            </div>
            <div className="text-lg font-bold text-[#037602] mt-1">
              {user.office}
            </div>
          </div>
        )}
      </div>

      {/* Right Section - User Info */}
      <div className="flex-1 flex items-center justify-end space-x-4">
        {/* User Info */}
        <div className="text-right">
          <div className="text-sm font-semibold">
            Welcome, {user.name || "Guest"}
          </div>
          <div className="text-xs text-gray-500 capitalize">{user.role || "Role"}</div>
        </div>

        {/* User Image */}
        <div className="flex items-center space-x-2">
          <img
            src={user.image || "http://placehold.co/40x40"}
            alt={user.name || "User"}
            className="w-10 h-10 rounded-full border-2 border-gray-200"
          />
          <FaCaretDown className="text-gray-500" />
        </div>
      </div>
    </div>
  );
};

export default Header;